import { Component, OnInit } from '@angular/core';
import { AuthStatusService } from 'src/app/services/auth-status.service';

@Component({
  selector: 'app-parent-products',
  templateUrl: './parent-products.component.html',
  styleUrls: ['./parent-products.component.scss']
})
export class ParentProductsComponent implements OnInit {

  groups: string[];
  constructor(
    private authStatusService: AuthStatusService,
  ) { 
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    }
    catch {
      this.groups = [];
    }
  }

  ngOnInit(): void {
  }

}
